import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { Link, useNavigate } from 'react-router-dom';

const MiniCart = ({ isOpen }) => {
  const { cart, removeFromCart } = useCart();
  const navigate = useNavigate();

  const subtotal = cart.reduce((sum, item) => sum + item.price * (item.quantity || 1), 0).toFixed(2);

  return (
    <div
      className="absolute right-0 top-full z-50"
    >
      {isOpen && (
        <div className="w-72 bg-white shadow-lg rounded border mt-2 transition-all duration-300 ease-in-out">
          <div className="p-4 max-h-80 overflow-y-auto divide-y">
            {cart.length === 0 ? (
              <p className="text-center text-sm text-gray-500">Your cart is empty</p>
            ) : (
              cart.map((item) => (
                <div key={item._id} className="py-2 flex gap-3">
                  <img
                    src={item.photos?.[0] ? `/uploads/${item.photos[0].replace(/\\/g, '/')}` : '/fallback.jpg'}
                    alt={item.name}
                    className="w-12 h-12 object-cover rounded border"
                  />
                  <div className="flex-1">
                    <p className="text-sm font-semibold truncate">{item.name}</p>
                    <p className="text-xs text-gray-600">Qty: {item.quantity || 1}</p>
                    <p className="text-sm text-blue-700 font-medium">${item.price.toFixed(2)}</p>
                  </div>
                  <button
  onClick={() => removeFromCart(item._id, item.size)}
  className="text-xs text-red-500 hover:underline"
>
  Remove
</button>
                </div>
              ))
            )}
          </div>
          {cart.length > 0 && (
            <div className="border-t p-4 text-sm">
              <div className="flex justify-between font-semibold mb-3">
                <span>Subtotal:</span>
                <span>${subtotal}</span>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => navigate('/cart')}
                  className="flex-1 text-center bg-gray-200 hover:bg-gray-300 py-1 rounded"
                >
                  View Cart
                </button>
                <button
                  onClick={() => navigate('/checkout')}
                  className="flex-1 text-center bg-blue-600 text-white hover:bg-blue-700 py-1 rounded"
                >
                  Checkout
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MiniCart;
